import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSidebar } from "../context/SidebarOpenContext";
import ReusableDataTable from "../hooks/ReusableDataTable";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "flowbite-react";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import PurchaseBillEntryForm from "../component/PurchaseBillEntryForm";
import { HiOutlineExclamationCircle } from "react-icons/hi";

function PurchaseBillsPage() {
    const navigate = useNavigate();
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { isSidebarOpen } = useSidebar();
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const handleEditClick = (row) => {
        setSelectedPurchase(row);     // ✅ this sets the data for the form
        setShowEditModal(true);       // ✅ this shows the modal
    };


    const handleDeleteClick = (row) => {
        console.log(row)
        setDeleteData(row);
        setShowDeleteModal(true);
    };

    const fetchPurchaseBills = async () => {
        try {
            setLoading(true);
            const response = await axios.get("/purchase_bill/purchases");
            setPurchases(response.data || []);
        } catch (err) {
            console.error("Failed to fetch:", err);
            setError("Failed to fetch purchase bills.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPurchaseBills();
    }, []);

    const confirmDelete = async () => {
        try {
            await axios.delete(`/purchase_bill/purchases/${deleteData.id}`);
            alert("Purchase deleted");
            setShowDeleteModal(false);
            // fetchData(); // refresh table
        } catch (err) {
            alert("Failed to delete: " + err.response.data.error);
        }
    };

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true, wrap: true },
        { name: "Purchase No", selector: (row) => row.purchase_no, sortable: true, wrap: true },
        { name: "Date", selector: (row) => new Date(row.date).toLocaleDateString(), sortable: true, wrap: true },
        { name: "Invoice No", selector: (row) => row.invoice_no || "-", sortable: true, wrap: true },
        { name: "Invoice Date", selector: (row) => row.invoice_date ? new Date(row.invoice_date).toLocaleDateString() : "-", sortable: true, wrap: true },
        { name: "Vendor", selector: (row) => row.vendor_name, sortable: true, wrap: true },
        { name: "Trims", selector: (row) => row.raw_material_name || "-", sortable: true, wrap: true },
        { name: "Fabric", selector: (row) => row.fabric_content || "-", sortable: true, wrap: true },
        { name: "Quantity", selector: (row) => row.quantity, sortable: true, wrap: true },
        { name: "Rate", selector: (row) => row.rate, sortable: true, wrap: true },
        { name: "Amount", selector: (row) => row.amount, sortable: true, wrap: true },
        {
            name: "Option",
            cell: (row) => (
                <div className="flex gap-2">
                    <FaPen
                        className="ml-2 text-amber-400 text-xl"
                        onClick={() => handleEditClick(row)} // ✅ Clean now
                    />

                    <MdDeleteForever
                        className="ml-2 text-red-500 text-2xl"
                        onClick={() => handleDeleteClick(row)}
                    />
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            wrap: true,
        }
    ];


    return (
        <div className={`${isSidebarOpen ? "p-4 sm:ml-64" : "p-4"} bg-content-bg min-h-screen`}>
            <div className="p-4 rounded-lg mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button
                        onClick={() => setShowModal(true)}
                        className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                    >
                        Entry Purchase Bill
                    </Button>

                    {showModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                            <div className="bg-white rounded shadow-lg max-w-5xl w-full p-4 relative">
                                <PurchaseBillEntryForm onClose={() => setShowModal(false)} />
                            </div>
                        </div>
                    )}
                    {showEditModal && selectedPurchase && (
                        <Modal onClose={() => setShowEditModal(false)} title="Edit Purchase Bill">
                            <PurchaseBillEntryForm
                                editData={selectedPurchase}
                                onClose={() => setShowEditModal(false)}
                                onSuccess={() => {
                                    setShowEditModal(false);
                                    fetchPurchaseBills();
                                }}
                            />
                        </Modal>
                    )}


                    {showDeleteModal && deleteData && (
                        <Modal show={showDeleteModal} size="md" onClose={() => setShowDeleteModal(false)} popup>
                            <Modal.Header />
                            <Modal.Body>
                                <div className="text-center">
                                    <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                        Are you sure you want to delete purchase <strong>{deleteData.purchase_no}</strong>?
                                    </h3>
                                    <div className="flex justify-center gap-4">
                                        <Button color="failure" onClick={confirmDelete}>
                                            Yes, Delete
                                        </Button>
                                        <Button color="gray" onClick={() => setShowDeleteModal(false)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {loading ? (
                        <div className="text-center py-8 text-gray-600 font-medium">Loading Purchase Bills...</div>
                    ) : error ? (
                        <div className="text-center py-8 text-red-600 font-medium">{error}</div>
                    ) : (
                        <ReusableDataTable
                            title="Purchase Bills"
                            columns={columns}
                            data={purchases}
                            noDataMessage="No Purchase Bills Found"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default PurchaseBillsPage;
